/* sk-search-sort.js
   Adds a sort dropdown to the search results toolbar. The theme's native
   search sort <select> is empty/hidden (search has no sort_options), but
   Shopify search DOES honor the sort_by URL param, so this dropdown reloads
   the page with sort_by applied. Loaded as an external asset (minifier-safe). */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    if (location.pathname.indexOf('/search') !== 0) return;

    var OPTIONS = [
      ['relevance', 'Relevance'],
      ['best-selling', 'Best selling'],
      ['title-ascending', 'Alphabetically, A-Z'],
      ['title-descending', 'Alphabetically, Z-A'],
      ['price-ascending', 'Price, low to high'],
      ['price-descending', 'Price, high to low'],
      ['created-descending', 'Date, new to old']
    ];

    var params = new URLSearchParams(location.search);
    var current = params.get('sort_by') || 'relevance';

    var toolbars = document.querySelectorAll('.tlbr');
    toolbars.forEach(function (tb) {
      if (tb.querySelector('.sk-sort')) return;
      var wrap = document.createElement('div');
      wrap.className = 'sk-sort';
      var sel = document.createElement('select');
      sel.className = 'sk-sort__select';
      sel.setAttribute('aria-label', 'Sort search results');
      OPTIONS.forEach(function (o) {
        var op = document.createElement('option');
        op.value = o[0];
        op.textContent = o[1];
        if (o[0] === current) op.selected = true;
        sel.appendChild(op);
      });
      sel.addEventListener('change', function () {
        var p = new URLSearchParams(location.search);
        p.set('sort_by', sel.value);
        location.search = p.toString();
      });
      wrap.appendChild(sel);
      tb.appendChild(wrap);
    });
  });
})();

/* 2026-11-03 Elash: grid/list view toggle fix.
   theme.js builds the URL as "/collections/x&view=list" when the page has no
   query string ("&" instead of "?"), which Shopify answers with a 404. This
   listener runs first (capture phase on window) and stops the broken jQuery
   handler in theme.js. It sets ?view= while keeping sort, filter and page
   params. Remove once the .change-view handler in theme.js is fixed. */
(function () {
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.change-view') : null;
    if (!btn) return;
    var view = btn.getAttribute('data-view');
    if (!view) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var url = new URL(window.location.href);
    if (url.searchParams.get('view') === view) return;
    url.searchParams.set('view', view);
    window.location.href = url.toString();
  }, true);
})();
